"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalContent = exports.ModalFooter = exports.ModalHeader = void 0;

var React = require("react");

var react_transition_group_1 = require("react-transition-group");

var styled_components_1 = require("styled-components");

var FiX_1 = require("@react-icons/all-files/fi/FiX");

var react_focus_on_1 = require("react-focus-on");

var Portal_1 = require("./Portal");

var utils_1 = require("../utils");

var animationDuration = 200;
var ModalContentWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n"], ["\n  padding: 20px;\n"])));
var ModalBackdrop = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      size = _a.size,
      transitionState = _a.transitionState;
  var defaultStyle = {
    transition: "opacity " + animationDuration + "ms ease-in-out",
    opacity: 0
  };
  var transitionStyles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Modal', variant, size);
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      z-index: 999;\n      display: flex;\n      align-items: center;\n      position: fixed;\n      overflow-y: auto;\n      overflow-x: hidden;\n      background: ", ";\n      justify-content: center;\n      transition: opacity ", "ms ease-in-out;\n\n      ", "\n      ", "\n    "], ["\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      z-index: 999;\n      display: flex;\n      align-items: center;\n      position: fixed;\n      overflow-y: auto;\n      overflow-x: hidden;\n      background: ", ";\n      justify-content: center;\n      transition: opacity ", "ms ease-in-out;\n\n      ", "\n      ", "\n    "])), themeStyles.backdropColor, animationDuration, defaultStyle, transitionStyles[transitionState]);
});
var Spacer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 16px 24px;\n"], ["\n  padding: 16px 24px;\n"])));
var ModalHeaderWrapper = styled_components_1.default(Spacer)(function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      size = _a.size;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Modal', variant, size);
  return "\n    position: relative;\n    border-bottom: 1px solid " + themeStyles.borderColor + ";\n    border-radius: 4px 4px 0 0;\n    min-height: 55px;\n  ";
});
var ModalFooterWrapper = styled_components_1.default(Spacer)(function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      size = _a.size;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Modal', variant, size);
  return "\n    border-top: 1px solid " + themeStyles.borderColor + ";\n    border-radius: 0 0 4px 4px;\n  ";
});
var ModalMain = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      size = _a.size,
      transitionState = _a.transitionState;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Modal', variant, size);
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", ";\n      ", ";\n      position: relative;\n      margin: auto;\n      background-clip: padding-box;\n      min-width: 300px;\n      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n      min-height: 100px;\n      color: ", ";\n      pointer-events: auto;\n      background-color: ", ";\n      border-radius: 4px;\n    "], ["\n      ", ";\n      ", ";\n      position: relative;\n      margin: auto;\n      background-clip: padding-box;\n      min-width: 300px;\n      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n      min-height: 100px;\n      color: ", ";\n      pointer-events: auto;\n      background-color: ", ";\n      border-radius: 4px;\n    "])), transitionState === 'entering' && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          animation: ", "ms ", ";\n        "], ["\n          animation: ", "ms ", ";\n        "])), animationDuration, utils_1.getAnimation('zoomIn')), transitionState === 'exiting' && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          animation: ", "ms ", ";\n        "], ["\n          animation: ", "ms ", ";\n        "])), animationDuration, utils_1.getAnimation('zoomOut')), themeStyles.color, themeStyles.backgroundColor);
});
var CloseButton = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  height: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 35px;\n  top: 0;\n"], ["\n  position: absolute;\n  right: 0;\n  height: 100%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 35px;\n  top: 0;\n"])));
var ModalContext = React.createContext({});

function ModalHeader(_a) {
  var children = _a.children,
      other = __rest(_a, ["children"]);

  var handleClose = React.useContext(ModalContext).handleClose;
  return React.createElement(ModalHeaderWrapper, __assign({
    "data-testid": "modal__header"
  }, other), React.createElement(React.Fragment, null, children, React.createElement(CloseButton, {
    onClick: function onClick(event) {
      return handleClose({
        trigger: 'closeClick',
        event: event
      });
    },
    "data-testid": "modal__close-button"
  }, React.createElement(FiX_1.FiX, {
    size: 20
  }))));
}

exports.ModalHeader = ModalHeader;

function ModalFooter(_a) {
  var children = _a.children,
      other = __rest(_a, ["children"]);

  return React.createElement(ModalFooterWrapper, __assign({
    "data-testid": "modal__footer"
  }, other), children);
}

exports.ModalFooter = ModalFooter;

function ModalContent(_a) {
  var children = _a.children,
      other = __rest(_a, ["children"]);

  return React.createElement(ModalContentWrapper, __assign({
    "data-testid": "modal__content"
  }, other), children);
}

exports.ModalContent = ModalContent;

function Modal(_a) {
  var backdropProps = _a.backdropProps,
      children = _a.children,
      _b = _a.closeOnBackdropClick,
      closeOnBackdropClick = _b === void 0 ? false : _b,
      _c = _a.disableAutoFocus,
      disableAutoFocus = _c === void 0 ? false : _c,
      _d = _a.disableFocusOn,
      disableFocusOn = _d === void 0 ? false : _d,
      _e = _a.disableOnClickOutside,
      disableOnClickOutside = _e === void 0 ? false : _e,
      _f = _a.disableOnEscapeKey,
      disableOnEscapeKey = _f === void 0 ? false : _f,
      _g = _a.disableReturnFocus,
      disableReturnFocus = _g === void 0 ? false : _g,
      focusOnProps = _a.focusOnProps,
      onClose = _a.onClose,
      _onEscapeKey = _a.onEscapeKey,
      _onClickOutside = _a.onClickOutside,
      show = _a.show,
      transitionProps = _a.transitionProps,
      variant = _a.variant,
      other = __rest(_a, ["backdropProps", "children", "closeOnBackdropClick", "disableAutoFocus", "disableFocusOn", "disableOnClickOutside", "disableOnEscapeKey", "disableReturnFocus", "focusOnProps", "onClose", "onEscapeKey", "onClickOutside", "show", "transitionProps", "variant"]);

  var handleClose = function handleClose(info) {
    if (onClose) {
      setTimeout(onClose(info), animationDuration);
    }
  };

  if (closeOnBackdropClick) {
    console.warn('UI-Core Deprecation Warning:', 'closeOnBackdropClick deprecated in 1.5.9, to be removed in 2.0. Use the closeOnBackdropClick prop instead');
  }

  var childrenWithProps = React.Children.map(children, function (child) {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        variant: variant
      });
    }

    return child;
  });
  return React.createElement(ModalContext.Provider, {
    value: {
      handleClose: handleClose
    }
  }, React.createElement(Portal_1.Portal, null, React.createElement(react_transition_group_1.Transition, __assign({
    in: show,
    timeout: animationDuration,
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true
  }, transitionProps), function (state) {
    return React.createElement(ModalBackdrop, __assign({
      transitionState: state,
      "data-testid": "modal__backdrop"
    }, backdropProps), React.createElement(react_focus_on_1.FocusOn, __assign({
      enabled: !disableFocusOn,
      onEscapeKey: function onEscapeKey(event) {
        if (disableOnEscapeKey) {
          return;
        }

        if (_onEscapeKey) {
          _onEscapeKey(event);
        } else {
          handleClose({
            trigger: 'onEscapeKey',
            event: event
          });
        }
      },
      onClickOutside: function onClickOutside(event) {
        if (closeOnBackdropClick || disableOnClickOutside) {
          return;
        }

        if (_onClickOutside) {
          _onClickOutside(event);
        } else {
          handleClose({
            trigger: 'onClickOutside',
            event: event
          });
        }
      },
      autoFocus: !disableAutoFocus,
      returnFocus: !disableReturnFocus
    }, focusOnProps), React.createElement(ModalMain, __assign({
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      "data-testid": "modal",
      variant: variant
    }, other), childrenWithProps)));
  })));
}

exports.Modal = Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;